
<template>
  <div class="resource-detail-page" :class="pageType === 'topic' ? 'topic-detail-page' : ''">
    <div 
      v-if="dataList.length"
      class="paly-box content-width-1300"
      >
      <div class="paly-box-left">
        <div v-if="pageType === 'topic'" class="play-content">
          <h5-video
            v-if="videoUrl && playInfo.resourceId"
            class="h5-video"
            ref="videoWrapper"
            :isTrailer="isTrailer"
            :trailerDuration="trailerDuration"
            :tValue="!isLogin || notFree ? '' : tValue"
            :videoUrl="notFree ? '/student/resourceAuthentication/' + randomData : videoUrl"
            :coverUrl="coverUrl"
            :hadLogo="playInfo.hadLogo"
            :level="playInfo.level ? playInfo.level : (playInfo.levelId ? playInfo.levelId: 2)"
            :subject="playInfo.subjectId"
          ></h5-video>
          <transition name="el-fade-in-linear">
            <div class="not-free" @click.stop v-if="notFree">
              <i class="iconfont iconsuo2"></i>
              <!-- <p class="not-free-line">付费内容，<span class="is-color" @click.stop="_push('purchase')">购买 </span>后才能查看此内容！已购买？<span class="is-color" @click.stop="_push('bind')">立即绑卡</span></p> -->
            </div>
          </transition>
          <div class="play-content-empty" v-if="!dataList.length && !listLoading">
            <img src="../../assets/resource-empty.png" alt class="empty-img" />
            <p>暂无数据~</p>
          </div>
        </div>
        <div 
          v-if="pageType === 'examination'" 
          class="play-content"
          v-loading="listLoading"
          element-loading-text="数据正在跑步前进中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="grba(255, 255, 255, 0.5)"
          >
          <DocPreview 
            v-if="!notFree" 
            :key="playInfo.fileUrl" 
            :pdfUrl="playInfo.fileUrl" 
            @finishLoading="_pdfFinishLoading" 
            :class="listLoading ? '' : 'doc-preview' " 
            :resourceId="playInfo.resourceId"
            :level="playInfo.subjectId"
            :subject="playInfo.subjectId"
            />
          <img v-if="notFree" class="examination-cover" :src="playInfo.coverUrl" alt="">
          <transition name="el-fade-in-linear">
            <div class="not-free" @click.stop v-if="notFree">
              <i class="iconfont iconsuo2"></i>
              <!-- <p class="not-free-line">付费内容，<span class="is-color" @click.stop="_push('purchase')">购买 </span>后才能查看此内容！已购买？<span class="is-color" @click.stop="_push('bind')">立即绑卡</span></p> -->
            </div>
          </transition>
        </div>
        <div class="resource-info">
          <div class="resource-info1">
            <p v-if="playInfo.resourceTitle" class="resource-title no-wrap">{{playInfo.resourceTitle}}</p>
            <template v-if="isLogin && playInfo && playInfo.resourceId && ((accountInfo.needBinding && playInfo.isFree) || !accountInfo.needBinding)">
              <span v-if="playInfo.hasCollect" class="collection-tip float-right" @click.stop="_collection(false)"><i class="iconfont iconshoucang"></i>已收藏</span>
              <span v-else-if="!playInfo.hasCollect" class="collection-tip1 float-right" @click.stop="_collection(true)" title="点击收藏"><i class="iconfont iconshoucang1"></i>收藏</span>
              <span v-if="pageType === 'examination'" class="download-tip float-right" @click.stop="_download(playInfo)"><i class="iconfont iconxiazai3"></i>下载</span>
            </template>
            <p v-if="pageType === 'topic' && playInfo.resourceTitle" class="resource-crumbs no-wrap">{{playInfo.subjectName}}{{playInfo.editionName}} / {{playInfo.volumeName}} / {{playInfo.chapterOneTitle }}</p>
          </div>
          <div class="resource-info2">
            <!-- <span v-if="playInfo.createdBy" class="created-by">{{playInfo.createdBy}}</!-->
            <span class="iconfont iconliulanliang1 no-wrap">{{playInfo.playCount ? playInfo.playCount : 0}}</span>
            <span v-if="playInfo.createdTime" class="created-time iconfont iconshijian-shangchuanshijian no-wrap">{{playInfo.createdTime | formatDateTime}}</span>
            <span v-if="pageType === 'examination'" class="iconfont iconxiazai1 no-wrap">下载{{playInfo.downloadCount ? playInfo.downloadCount : 0}}次</span>
            <span v-if="pageType === 'examination'" class="iconfont icondaxiao1 no-wrap">{{playInfo.fileSize | fileSize}}</span>
          </div>
          <p v-if="playInfo.resourceTitle" class="resource-desc" @mouseenter="playInfo.description && _descEnter($event)">
            <span class="desc-title">{{playInfo.description ? '视频简介：' : '暂无简介'}}</span>
            <span class="desc-content no-wrap-3">{{playInfo.description}}</span>
          </p>
          <p v-if="playInfo.examTypeName" class="line-p">
            <span class="classes-label">{{playInfo.examTypeName}}</span>
          </p>
          <p v-else-if="playInfo.categoryName" class="line-p">
            <span class="classes-label">{{playInfo.categoryName}}</span>
          </p>
          
        </div>
      </div>
      <div class="related-info">
        <p class="related-title">{{pageType === 'topic' ? '专题目录' : '相关资源'}}<span v-if="pageType === 'topic'"><span class="select-index">{{selectIndex + 1}}</span> / {{dataList.length}}</span></p>
        <div 
          :class="{
            'related-list-box': true,
          }"
          >
          <div class="in-related-list" id="relatedInList">
            <resource-item 
              v-for="item in dataList" 
              :key="item.resourceId" 
              :item="item" 
              :component-type="pageType" 
              :class="{
                'is-select': resourceId === item.resourceId
              }"
              :id="'resource_' + item.resourceId"
              @handleClick="_resourceChange"
              @handleLimit="_limit"
              :all-click="true"
              >
              <span v-if="(accountInfo && accountInfo.needBinding && item.isFree) || (!accountInfo && item.isFree)" class="free-tip" slot="topLeft">试看</span>
              </resource-item>
          </div>
        </div>
      </div>
    </div>  
    <div 
      v-else-if="!dataList.length"
      class="paly-box paly-box-empty content-width-1300"
      v-loading="listLoading"
      element-loading-text="数据正在跑步前进中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)" 
      >
      <div class="resource-list-box empty" v-if="!listLoading">
        <img src="../../assets/resource-empty.png" alt class="empty-img" />
        <p>暂无数据~</p>
      </div>
    </div>
    <!-- 弹框 -->
    <LimitDialog :visible="operateDialogVisible" @handleClick="_closeDialog" />

    <!-- 下载进度的弹窗 -->
    <ResourceDownloadDialog :downloadItem="downloadItem" />
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { mapState } from "vuex";
import { originUrl } from "config/constant";
import { localStorageUtil } from "utils/util";
import h5Video from "components/h5video";
import DocPreview from 'components/doc-ppt-preview/doc-preview';
import ResourceItem from 'components/resource-item';
import LimitDialog from 'components/limit-dialog';
import { reqGetResourceList } from 'api/synchronous-courses';
import { reqGetTopicResource } from "api/topic-classes";
import { reqGetExaminationDetail } from "api/examination";
import { reqCollectStatus, reqAddHistory } from 'api/common';
import ResourceDownloadDialog from 'components/resource-download-dialog';
export default {
  name: 'PlayPage',
  components: {
    ResourceItem,
    h5Video,
    DocPreview,
    LimitDialog,
    ResourceDownloadDialog
  },
  data() {
    return {
      listLoading: true,
      queryObj: {},
      paramsObj: {},
      videoVisible: true,
      isTrailer: false,
      trailerDuration: 0,
      videoUrl: "",
      coverUrl: "",
      tValue: "bearer " + Cookies.get("mvr_student_Token"),
      imgSrc: originUrl.indexOf('http://localhost:') !== -1
        ? "http://mvr-resource.viewshare.net"
        : originUrl,
      dataInfo: {},
      dataList: [],
      playInfo: {},
      resourceId: null,
      selectIndex: 0,
      preDis: true,
      nextDis: false,
      noScroll: false,
      descEnter: false,
      fromType: 'playPage',
      operateDialogVisible: false,
      randomData: 'random' + new Date().getTime(),
      videoStatistics: null,
      pageType: 'topic', // topic--专题课程 examination--试卷库
      downloadItem: null,
    };
  },
  filters: {
    formatDateTime(val) {
      if(!val) {
        return '';
      }
      let dt = new Date(val);
      let str = ""; //存储时间的字符串
      //获取年
      let year = dt.getFullYear();
      //获取月
      let month = dt.getMonth() + 1;
      //获取日
      let day = dt.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    }
  },
  computed: {
    ...mapState(["accountInfo", "isLogin"]),
    notFree() {
      if(this.playInfo.resourceId && !this.playInfo.canPlay && this.isLogin) {
        return true;
      }else {
        return false;
      }
    },
    showFree(item) {
      if(this.playInfo.componentType == 'homeHot' || this.playInfo.componentType === 'homeNew') {
        return false;
      }else if(this.dataList.length && this.accountInfo && this.accountInfo.needBinding && item.isFree) {
        return true;
      }else {
        return false;
      }
    }
  },
  methods: {
    _closeDialog(flag = true) {
      this.operateDialogVisible = flag;
    },
    /**
     * 未登录/未绑卡时的提示
     * **/
    _limit(data) {
      this.operateDialogVisible = true;
    },
    _operateDialogOk(type) {
      this._operateDialogClose();
      if(type === 'bind') {
        this.$router.push('/binding-card');
      }else if(type === 'login') {
        this.$router.push('/home-page');
      }else if(type === 'register') {
        this.$router.push('/register');
      }else if(type === 'purchase') {
        let routeUrl = this.$router.resolve({
          path: "/purchase/product-details",
          query: {
            productId: 1
          }
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    /**
     * 关闭操作弹框
     * **/
    _operateDialogClose() {
      this.operateDialogVisible = false;
    },
    /**
     * 鼠标移入简介
     * **/
    _descEnter(e) {
      return;
      if(this.descEnter || !e.target) {
        return;
      }
      this.descEnter = true;
     
      let _w = $(e.target).width();
      let _h = $(e.target).height();
      let $c = $(e.target).clone().css({width: _w, fontSize: '14px', lineHeight: '24px',visibility: 'hidden'}).appendTo('body');
      $c.removeClass('no-wrap');
      $(e.target).removeClass('no-wrap');
      if($c.height() > _h) {
        $(e.target).animate({
          height: $c.height()
        }, function() {
        });
      }
      $c.remove();
    },
    /**
     * 收藏 取消收藏
     * **/
    _collection() {
      let obj = {
        resourceId: this.playInfo.resourceId
      }
      return reqCollectStatus(Object.assign({}, this.paramsObj, obj))
        .then(res => {
          if (res.code === 0) {
            this.playInfo.hasCollect = !this.playInfo.hasCollect;
            let _index = this.dataList.findIndex(ele => ele.resourceId === this.playInfo.resourceId);
            this.dataList[_index].hasCollect = this.playInfo.hasCollect;
            this.dataList = [...this.dataList];
            this.$message({
              type: 'success',
              message: this.playInfo.hasCollect ? "收藏成功~" : "已取消收藏~",
              duration: 2000
            });
          } else {
            this.$message({
              type: "error",
              message: this.playInfo.hasCollect ? "取消收藏失败~" : "收藏失败~",
              duration: 2000
            });
          }
        })
        .catch(err => {
          console.log("收藏/取消收藏失败", err);
        });

    },
    /**
     * 新增历史记录
     * **/
    _history(item) {
      if(!this.isLogin) {
        return;
      }
      let obj = {
        resourceId: item.resourceId
      };
      
      return reqAddHistory(Object.assign({}, this.paramsObj, obj))
        .then(res => {
          if (res.code === 0) {
          
          } else {
            console.log("新增历史记录失败", res);
            // this.$message({
            //   type: "error",
            //   message: this.playInfo.hasCollect ? "取消收藏失败" : "收藏失败",
            //   duration: 2000
            // });
          }
        })
        .catch(err => {
          console.log("新增历史记录失败", err);
        });

    },
    
    /**
     * 资源--下载
     * **/
    _download(item) {
      if(!this.isLogin || (this.accountInfo && this.accountInfo.needBinding)) {
        this._limit();
        console.log('not login', this.isLogin);
        return;
      }
      let obj = this._getDownloadParams(item);
      if(this.downloadItem) {
        this.downloadItem = null;
        setTimeout(() => {
          this.downloadItem = Object.assign({downloadParams: obj, downloadId: obj.resourceId}, item);
        }, 50);
      }else {
        this.downloadItem = Object.assign({downloadParams: obj, downloadId: obj.resourceId}, item);
      }

    },

    /**
     * 资源--下载--设置发送参数
     * **/
    _getDownloadParams(item) {
      let obj = {
        belongType: 'examination',
        fileSize: item.fileSize,
        index: item.index,
        isWatched: item.isWatched,
        id: item.id,
        resourceId: item.resourceId,
        fileName: item.resourceTitle + ".docx",
        levelId: item.levelId,
        subjectId: item.subjectId,
        needStatistics: true
      };
      return obj;
    },
    
    /**
     * 获取数据--专题课程
     * **/
    _getDataList(type) {
      this.listLoading = true;
      let obj = {
        topicClassesId: this.queryObj.topicClassesId
      };
      return reqGetTopicResource(Object.assign({}, this.paramsObj, obj))
        .then(res => {
          setTimeout(() => {
            this.listLoading = false;
          }, 200);
          if (res.code === 0) {
            this.dataInfo = res.data;
            let _dataList = res.data;
            if(!_dataList.length) {
              this.dataList = [];
              this._queryChange();
              return;
            }else {
              let _isLogin = localStorageUtil.getItem('isLogin');
              let _accountInfo = localStorageUtil.getItem('accountInfo');
              for(let i = 0; i < _dataList.length; i++) {
                let x = _dataList[i];
                x.index = i;
                if(!_isLogin) { // 未登录
                  x.canPlay = false;
                }else if(_accountInfo.needBinding) { // 已登录未绑卡
                  if(x.isFree) {
                    x.canPlay = true;
                  }else {
                    x.canPlay = false;
                  }
                }else { // 已登录已绑卡
                  x.canPlay = true;
                }
              }
              this.dataList = [..._dataList];
            }
            this._resourceChange();
            
          } else if(res.code === 14001) {
            this.dataList = [];
            this.playInfo = {};
            if(!this.operateDialogVisible) {
              this.operateDialogVisible = true;
            }
          } else {
            this.dataList = [];
            this.playInfo = {};
            this.$message({
              type: "error",
              message: "数据获取失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.dataList = [];
          this.playInfo = {};
          setTimeout(() => {
            this.listLoading = false;
          }, 200);
          console.log("数据获取失败", err);
        });
    },
    /**
     * 获取数据--试卷库
     * **/
    _getDataList1(type) {
      this.listLoading = true;
      let obj = {
        resourceId: this.queryObj.resourceId
      }
      return reqGetExaminationDetail(Object.assign({}, this.paramsObj, obj))
        .then(res => {
          if (res.code === 0) {
            this.dataInfo = res.data;
            let _dataList = res.data.relatedResources;
            let _dataObj = res.data.resource[0];
            if(!_dataList.length && !res.data.resource.length) {
              this.listLoading = false;
              this.dataList = [];
              this._queryChange();
              return;
            }else {
              let i = _dataList.findIndex(ele => ele.resourceId === _dataObj.resourceId);
              if(i === -1) {
                _dataList.unshift(_dataObj);
              }else {
                _dataList.splice(i, 1, _dataObj);
              }
              let _isLogin = localStorageUtil.getItem('isLogin');
              let _accountInfo = localStorageUtil.getItem('accountInfo');
              for(let i = 0; i < _dataList.length; i++) {
                let x = _dataList[i];
                x.index = i;
                if(!_isLogin) { // 未登录
                  x.canPlay = false;
                }else if(_accountInfo.needBinding) { // 已登录未绑卡
                  if(x.isFree) {
                    x.canPlay = true;
                  }else {
                    x.canPlay = false;
                  }
                }else { // 已登录已绑卡
                  x.canPlay = true;
                }
              }
              this.dataList = [..._dataList];
            }
            this._resourceChange();
            
          } else if(res.code === 14001) {
            this.dataList = [];
            this.playInfo = {};
            this.listLoading = false;
            if(!this.operateDialogVisible) {
              this.operateDialogVisible = true;
            }
          } else {
            this.dataList = [];
            this.playInfo = {};
            this.listLoading = false;
            this.$message({
              type: "error",
              message: "数据获取失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.dataList = [];
          this.playInfo = {};
          setTimeout(() => {
            this.listLoading = false;
          }, 200);
          console.log("数据获取失败", err);
        });
    },
    _pdfFinishLoading(type) {
      setTimeout(() => {
        this.listLoading = false;
      }, 50);
    },
    /**
     * 点击资源播放
     * **/
    _resourceChange(data) {
      console.log('=====================')
      if(data && data.resourceId === this.resourceId) {
        return;
      }
      this.randomData = 'random' + new Date().getTime();
      if(!data && this.queryObj.topicClassesId && !this.queryObj.resourceId) {
        this.selectIndex = this._topicHistoryStorage('get');
      }else if(!data && this.queryObj.topicClassesId && this.queryObj.resourceId) {
        let i = this.dataList.findIndex(ele => ele.resourceId == this.queryObj.resourceId);
        if(i !== -1) {
          this.selectIndex = i;
        }
        this._topicHistoryStorage('set', this.dataList[this.selectIndex]);
      }else if(data) {
        if(!isNaN(data.index)) {
          this.selectIndex = data.index;
        }
        if(this.pageType === 'topic') {
          this._topicHistoryStorage('set', data);
        }
      }
      let _repeat = false;
      if(this.dataList[this.selectIndex].resourceId === this.playInfo.resourceId) {
        _repeat = true;
      }
      this.playInfo = Object.assign({}, this.dataList[this.selectIndex]);
      this.playInfo.componentType = this.fromType;
      this.resourceId = this.playInfo.resourceId;
      this._operateResource(_repeat ? 'repeat' : undefined);
      this._queryChange(this.playInfo, data ? false : true);
      if(this.playInfo.canPlay) {
        this._history(this.playInfo);
      }
      if(data) {
        this.listLoading = true;
        if(data.componentType === 'homeHot' || data.componentType === 'homeNew') {
          this._getDirectoryTitle();
        }
      }else {
        this.$nextTick(() => {
          let box = $('#relatedInList');
          let boxH = box.height();
          let boxT = box.offset().top;
          let nowEle =$(`#resource_${this.resourceId}`);
          let nowEleT = nowEle.offset().top;
          if(nowEleT - boxT > boxH - 100) {
            nowEle[0].scrollIntoView({behavior: 'smooth'});
          }
        });
        
      }
      if(!data && !this.playInfo.canPlay) {
        this._limit(this.playInfo);
        this.listLoading = false;
      }
      document.title = this.playInfo.resourceTitle + ' - 小山云课';
    },
    /**
     * 修改query
     * **/
    _queryChange(data, scrollTop = true) {
      let obj = Object.assign({}, this.queryObj, {index: this.selectIndex});
      if(this.pageType === 'topic') {
      }
      this.$router.push({
        path: "/resource-detail",
        query: obj
      });
      this.$nextTick(() => {
        if(scrollTop) {
          document.querySelector('.home-wrapper').scrollIntoView({});
        }
        
      });
    },
    /**
     * 处理当前要播放的资源
     * **/
    _operateResource(type) {
      if(this.$refs.videoWrapper) {
        this.$refs.videoWrapper._videoPause();
      } 
      if(type === 'repeat') {
        this.videoUrl = '';
        setTimeout(() => {
          this.resourceId = this.playInfo.resourceId;
          this.videoUrl = `/student/resourceAuthentication/${this.playInfo.resourceId}`;
          let _index = this.playInfo.coverUrl.indexOf('/images/');
          this.coverUrl = this.playInfo.coverUrl.substring(_index);
          if(this.playInfo.fileUrl && this.playInfo.fileUrl.indexOf('.mp4') === this.playInfo.fileUrl.length - 4 && this.playInfo.fileUrl.indexOf('http') === 0) {
            this.videoUrl = this.playInfo.fileUrl;
          }
        }, 100);
      }else {
        this.resourceId = this.playInfo.resourceId;
        this.videoUrl = `/student/resourceAuthentication/${this.playInfo.resourceId}`;
        let _index = this.playInfo.coverUrl.indexOf('/images/');
        this.coverUrl = this.playInfo.coverUrl.substring(_index);
        if(this.playInfo.fileUrl && this.playInfo.fileUrl.indexOf('.mp4') === this.playInfo.fileUrl.length - 4 && this.playInfo.fileUrl.indexOf('http') === 0) {
          this.videoUrl = this.playInfo.fileUrl;
        }
      }
      // this.playInfo.description = "综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落";
    },
    /**
     * 专题课记录上次学习到哪个
     * **/
    _topicHistoryStorage(type, item) {
      let _storge = localStorageUtil.getItem('topicHistory'); 
      if(type === 'set' && this.dataList.length > 1) {
        if(!_storge) {
          _storge = {};
        }
        _storge[this.queryObj.topicClassesId] = item.resourceId;
        localStorageUtil.setItem('topicHistory', _storge);
      }else if(type === 'get') {
        let i = 0;
        if(_storge && _storge[this.queryObj.topicClassesId]) {
          i = this.dataList.findIndex(ele => ele.resourceId === _storge[this.queryObj.topicClassesId]);
          if(i !== -1) {
            return i;
          }
          i = 0;
        }
        return i;
      }
    },
    
    /**
     * 初始化参数处理
     * **/
    _getQuery() {
      let _query = this.$route.query;
      this.queryObj = Object.assign({}, _query);
      this.pageType = _query.type;
      this.selectIndex = _query.index ? Number(_query.index) : 0;
      let _stamp = _query.stamp;
      if(_stamp) {
        _stamp = _stamp.split('%');
        this.paramsObj = {
          subjectId: _stamp[0],
          editionId: _stamp[1],
          volumeId: _stamp[2]
        };
        if(_stamp[3]) {
          this.paramsObj.chapterOneId = _stamp[3];
        }
      }

      if(this.pageType === 'topic') {
        this._getDataList('init');
      }else if(this.pageType === 'examination') {
        this._getDataList1('init');
      }
      
    }
  },
  created() {
    this._getQuery();
  }
};
</script>

<style lang="less">
@color-main: #03B2B2;
.resource-detail-page {
  height: 756px;
  width: 100%;
  border-radius: 6px;
  margin-bottom: 20px;
  display: inline-block;
  vertical-align: top;
  margin-top: 20px !important;
  .paly-box {
    height: 756px;
    background: #D3F0F0;
    overflow: hidden;
    .paly-box-left {
      display: inline-block;
      width: 984px;
      height: 756px;
      vertical-align: top;
      // border-right: 1px solid #C8C8C8;
      .play-content {
        width: 100%;
        height: 554px;
        background: rgba(220, 227, 225, 0.5);
        position: relative;
        margin: 0 auto;
        .examination-cover {
          height: 100%;
          width: auto;
        }
        .video-div-box {
          background-image: url('../../assets/image-placeholder-2x.png');
          background-repeat: no-repeat;
          background-position: center;
          box-shadow: 0 0 1px 0px #f2f2f2;
        }
        .not-free {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 3;
          background: rgba(0, 0, 0, 0.4);
          text-align: center;
          .iconfont {
            display: inline-block;
            color: #fff;
            font-size: 60px;
            margin-top: 250px;
          }
          .not-free-line {
            font-size: 16px;
            line-height: 16px;
            margin-top: 10px;
            color: #fff;
            .is-color {
              color: #419EFF;
              cursor: pointer;
              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
        .play-content-empty {
          z-index: 4;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          p {
            text-align: center;
            height: 40px;
            line-height: 40px;
            color: #999;
          }
        }
        .teaching-plan-preview {
          background: #fff;
          margin-top: 0;
          height: 100% !important;
          .ppt-error {
            background-color: rgba(220,227,225,.5);
            background-image: url('../../assets/image-placeholder-2x.png');
            background-repeat: no-repeat;
            background-position: center;
            p {
              color: #d2d2d2;
              margin-top: 54px;
            }
          }
          &.preview-is-full {
            // background-image: url('../../assets/image-placeholder-2x.png');
            // background-repeat: repeat;
          }
          &.doc-preview {
            .pdf-style + .pdf-style {
              #viewerContainer {
                margin-top: 20px;
                position: relative;
                &::before {
                  content: '';
                  display: inline-block;
                  width: 100%;
                  height: 20px;
                  position: absolute;
                  left: 0;
                  top: -20px;
                  background: #e7e6e6;
                }
              }
            }
          }
          &.doc-preview.preview-is-full {
            .pdf-style + .pdf-style {
              #viewerContainer {
                &::before {
                  background: #000;
                }
              }
            }
          }
        }
        .el-loading-spinner {
          margin-top: -21px;
        }
      }
      .resource-info {
        width: 100%;
        height: calc(100% - 554px);
        background: #ffffff;
        padding: 18px 30px;
        border-top: 1px solid #E4EDE6;
        .resource-info1 {
          .resource-title {
            width: calc(100% - 170px);
            font-size: 20px;
            font-weight: bold;
            color: #4A4A4A;
            line-height: 28px;
            display: inline-block;
          }
          .resource-crumbs {
            width: calc(100% - 170px);
            height: 30px;
            line-height: 22px;
            padding-top: 8px;
            color: #999999;
          }
          .collection-tip {
            cursor: pointer;
            margin-top: 6px;
            height: 16px;
            .iconfont {
              padding-right: 4px;
              color: @color-main;
            }
          }
          .collection-tip1 {
            cursor: pointer;
            margin-top: 6px;
            .iconfont {
              padding-right: 4px;
            }
            &:hover {
              color: @color-main;
            }
          }
          .download-tip {
            cursor: pointer;
            margin-top: 8px;
            color: #666666;
            .iconfont {
              padding-right: 4px;
              font-size: 14px;
            }
            margin-right : 15px;
            &:hover {
              color: @color-main;
            }
          }
        }
        .resource-info2 {
          margin-top: 12px;
          margin-bottom: 18px;
          color: #999999;
          height: 16px;
          line-height: 16px;
          .iconfont {
            font-size: 14px;
            display: inline-block;
            padding-left: 1px;
            &.iconliulanliang1 {
              width: 110px;
            }
            &.icondaxiao1 {
              width: 150px;
            }
            &.iconshijian-shangchuanshijian {
              width: 140px;
            }
            &.iconxiazai1 {
              width: 130px;
            }
            &:before {
              padding-right: 6px;
              // display: inline-block;
            }
          }
        
        }
        .resource-desc {
          color: #717171;
          height: 60px;
          line-height: 20px;
          word-break:break-all;
          overflow: hidden;
          .desc-title {
            display: inline-block;
            width: 90px;
            font-weight: bold;
            font-size: 18px;
            vertical-align: top;
          }
          .desc-content {
            float: right;
            width: calc(100% - 90px);
            height: 60px !important;
            margin-top: -1px;
            vertical-align: top;

          }
        }
        .line-p {
          .classes-label {
            display: inline-block;
            // max-width: 192px;
            height: 24px;
            line-height: 24px;
            padding-left: 8px;
            padding-right: 6px;
            color: #fff;
            background: linear-gradient(180deg, #FFB53D 0%, #FF7E1C 100%);
            position: relative;
            &:after {
              content: '';
              display: inline-block;
              width: 10px;
              height: 24px;
              background-image: url('../../assets/topic-icon.png');
              background-repeat: no-repeat;
              background-position: right center;
              position: absolute;
              top: 0;
              right: -10px;
            }
          }
        }
      }
    }
    .related-info {
      display: inline-block;
      width: 316px;
      height: 756px;
      vertical-align: top;
      .related-title {
        height: 38px;
        padding: 9px 16px;
        color: #FFFFFF;
        background: #56C3C3;
        line-height: 20px;
        .select-index {
          color: #00FFFF;
          font-size: 18px;
          margin-left: 10px;
        }
      }
      .related-list-box {
        width: 100%;
        position: relative;
        height: calc(100% - 38px);
        overflow: auto;
        .in-related-list {
          height: 100%;
          margin-left: 0;
          .resource-item {
            display: block;
            width: 100%;
            height: 96px;
            padding: 10px 10px 10px 20px;
            background: transparent;
            border-radius: 0;
            border: none;
            margin: 0 !important;
            box-shadow: none;
            &:hover {
              &:not(.is-select) {
                background: #beebeb;
              }
              box-shadow: none;
              transform: none;
              cursor: pointer;
              .resource-item-title {
                color: #009494;
              }
            }
            .resource-item-top {
              width: 136px;
              height: 76px;
              border-radius: 4px;
              float: left;
              .el-image .image-slot .image-slot-placeholder {
                width: 104px;
                height: 24px !important;
              }
              
              .resource-duration {
                font-size: 12px;
                padding: 4px;
                bottom: 5px;
                right: 5px;
              }
            }
            .resource-item-title {
              width: calc(100% - 136px);
              margin: 0 !important;
              padding-top: 15px;
              padding-right: 0 !important;
              font-size: 14px;
              font-weight: normal;
              height: 55px;
              line-height: 20px;
              white-space: normal;

              overflow: hidden;
              text-overflow: ellipsis;
              display: inline-block;
              display: -webkit-box !important;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .resource-bottom-box {
              display: none;
            }
            &.is-select {
              background: #B6E3E3 !important;
              .resource-item-title {
                color: #009494;
              }
            }
          }
        }
      }
    }
  }
  .paly-box-empty {
    min-height: calc(100vh - 110px - 70px);
    width: 100%;
    position: relative;
    background: transparent !important;
    .empty {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      p {
        text-align: center;
        height: 40px;
        line-height: 40px;
        color: #999;
      }
    }
  }
  &.topic-detail-page {
    height: 786px;
    .paly-box {
      height: 786px;
      .paly-box-left {
        height: 786px;
      }
      .related-info {
        height: 786px;
      }
    }
  }
}

</style>